var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluetoothStrengthOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 58,
    viewBox: "0 0 36 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0166 57.3337V35.8003L3.98327 48.8337L0.0166016 44.867L15.8833 29.0003L0.0166016 13.1337L3.98327 9.16699L17.0166 22.2003V0.666992H19.8499L35.9999 16.817L23.8166 29.0003L35.9999 41.1837L19.8499 57.3337H17.0166ZM22.6833 22.2003L28.0666 16.817L22.6833 11.5753V22.2003ZM22.6833 46.4253L28.0666 41.1837L22.6833 35.8003V46.4253Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetoothStrengthOrange);
export default __webpack_public_path__ + "static/media/Bluetooth_Strength_Orange.681b54d6f3d110fca59845df092ca8e9.svg";
export { ForwardRef as ReactComponent };